module.exports = __webpack_public_path__ + "img/about-bg2.1055b238.png";